var _path, _path2, _circle, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoragebig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 35,
    viewBox: "0 0 28 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.7819C25 15.6631 23.2465 19.2321 21.3333 23.1548C18.8085 28.3315 15.788 33.6966 14 34.6802C12.1659 33.335 9.2133 28.3781 6.66667 23.1548C4.84955 19.4277 3 15.565 3 12.7819C3 6.09829 7.92487 0.680176 14 0.680176C20.0751 0.680176 25 6.09829 25 12.7819Z",
    fill: "#254E9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.7819C25 15.6631 23.2465 19.2321 21.3333 23.1548C18.8085 28.3315 15.788 33.6966 14 34.6802C12.1659 33.335 9.2133 28.3781 6.66667 23.1548C4.84955 19.4277 3 15.565 3 12.7819C3 6.09829 7.92487 0.680176 14 0.680176C20.0751 0.680176 25 6.09829 25 12.7819Z",
    fill: "#254E9C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.6802,
    r: 13,
    fill: "white",
    stroke: "#254E9C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.6802,
    r: 13,
    fill: "white",
    stroke: "#254E9C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 19.93V14.4466C11.0833 14.1199 11.0833 13.9566 11.1469 13.8318C11.2028 13.722 11.2921 13.6328 11.4018 13.5769C11.5266 13.5133 11.69 13.5133 12.0167 13.5133H15.9833C16.3101 13.5133 16.4734 13.5133 16.5982 13.5769C16.708 13.6328 16.7971 13.722 16.8531 13.8318C16.9167 13.9566 16.9167 14.1199 16.9167 14.4466V19.93M12.8333 15.8466H15.1667M12.8333 18.18H15.1667M8.75 13.798V18.9966C8.75 19.3233 8.75 19.4866 8.81358 19.6115C8.86951 19.7212 8.95875 19.8104 9.06851 19.8664C9.19329 19.93 9.35664 19.93 9.68333 19.93H18.3167C18.6434 19.93 18.8067 19.93 18.9315 19.8664C19.0413 19.8104 19.1305 19.7212 19.1864 19.6115C19.25 19.4866 19.25 19.3233 19.25 18.9966V13.798C19.25 13.1717 19.25 12.8585 19.1548 12.5818C19.0706 12.3371 18.9332 12.1142 18.7525 11.9289C18.5482 11.7195 18.2685 11.5787 17.709 11.2971L15.259 10.0637C14.7975 9.8314 14.5668 9.71523 14.3246 9.66952C14.1101 9.62904 13.8899 9.62904 13.6754 9.66952C13.4332 9.71523 13.2025 9.83139 12.741 10.0637L10.291 11.2971C9.73152 11.5787 9.45177 11.7195 9.24744 11.9289C9.06674 12.1142 8.92935 12.3371 8.84518 12.5818C8.75 12.8585 8.75 13.1717 8.75 13.798Z",
    stroke: "#254E9C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoragebig);
export default __webpack_public_path__ + "static/media/storage big.cc31993353d58bc075011db51e2b1782.svg";
export { ForwardRef as ReactComponent };